import { api } from '@/api/http'
import type { Review, CreatePartReviewPayload, CreateDealReviewPayload } from '../types/review.types'

export const reviewsService = {
  getHomepageReviews: () => api.get<Review[]>('/reviews/homepage'),

  getAllReviews: () => api.get<Review[]>('/reviews/all'),

  getMyReviews: () => api.get<Review[]>('/reviews/my-reviews'),

  submitPartReview: (payload: CreatePartReviewPayload) =>
    api.post<Review>('/reviews/parts', payload),

  submitDealReview: (payload: CreateDealReviewPayload) =>
    api.post<Review>('/reviews/deals', payload),
}
